import { SealCheck } from "@phosphor-icons/react";

/** Small purple chip shown next to members who signed in via SocialPulse SSO. */
export default function SocialPulseBadge({ provider, testid = "sp-verified-badge" }) {
  if (provider !== "socialpulse") return null;
  return (
    <span
      data-testid={testid}
      title="Verified sign-in via SocialPulse"
      className="inline-flex items-center gap-1 rounded-full bg-[#6D28D9]/10 text-[#6D28D9] border border-[#6D28D9]/25 px-2 py-0.5 font-mono-tech text-[8px] tracking-[0.16em] uppercase align-middle"
    >
      <SealCheck size={10} weight="fill" /> SocialPulse
    </span>
  );
}
